import React, { useState, useEffect } from "react"
import { createPortal } from "react-dom"
import MesacuatroView from "./Plantillas/Mesacuatro";
import MesaochoView from "./Plantillas/Mesasocho";
import MesaseisView from "./Plantillas/Mesaseis";
import MesadosView from "./Plantillas/Mesados";
import MesacerView from "./Plantillas/Mesacer";
import MesadiesView from "./Plantillas/Mesasdies"
import MesascatorceView from "./Plantillas/Mesascatorce";
import MesaExtraView from "./Plantillas/MesaExtra";
import './mesas.css'
import { useDispatch, useSelector } from "react-redux";
import { getDatosUsuariosLocalStorag } from "utils/DatosUsuarioLocalStorag";
import { EliminarsilladeMesa } from "utils/CarritoLocalStorang";
import { deleteSillas } from "StoreRedux/Slice/sillasSlice";
import { addSillas } from "StoreRedux/Slice/sillasSlice";
import { AgregarAsiento } from "utils/CarritoLocalStorang";
import { correlativosadd } from "utils/Querypanelsigui";
import SweetAlert from "react-bootstrap-sweetalert";
import { setSpinersli } from "StoreRedux/Slice/SuscritorSlice";
import { TotalSelecion } from "utils/CarritoLocalStorang";
import { setToastes } from "StoreRedux/Slice/ToastSlice";

import { clienteInfo } from "utils/DatosUsuarioLocalStorag"
import { logWithCallback } from "utilsstile.js/style";
import { displayMesaNombre } from "utils/constantes";
function MesasView({ text, status, list = [] }) {
  // list llega undefined cuando se usa MesasView solo para la etiqueta de la fila
  // (<MesasView text={fila.fila} />). Sin este default, MesaEstado y los
  // list.find/map/filter de abajo tiran "Cannot read properties of undefined
  // (reading 'length')" y se cae el modal de la localidad numerada.
  let nombre = JSON.parse(sessionStorage.getItem("seleccionmapa"))
  let usedispatch = useDispatch();
  const [alert, setAlert] = useState(null)
  // Los templates de mesa (Mesacuatro.js, etc.) pintan {alert} adentro de su
  // propio div, que en el mapa de mesas del cliente (Modallocalida.js) queda
  // anidado dentro de un contenedor con `transform: scale(zoomMesas)` (el
  // control de zoom +/-). Un `transform` en un ancestro crea un "containing
  // block" nuevo para los descendientes con position:fixed -- el SweetAlert
  // (que es position:fixed para cubrir toda la pantalla) quedaba encerrado
  // en el tamaño de ESA mesa en vez de la pantalla completa, por eso se veia
  // chico/cortado cuando la localidad tenia pocas mesas. Portarlo a
  // document.body lo saca de ese contenedor transformado sin cambiar nada
  // de su contenido ni de cuando se abre/cierra.
  const alertPortal = alert ? createPortal(alert, document.body) : null
  let user = getDatosUsuariosLocalStorag()
  const modalshow = useSelector((state) => state.SuscritorSlice.modal)
  var mapath = useSelector((state) => state.mapaLocalSlice.pathmap)
  function Estado(e) {
    let randon = sessionStorage.getItem("random") || ""
    let estado = list.find(f => f.silla == e)
    // Si el codigo de silla que arma la plantilla ("mesa-s-N") no calza con
    // ninguna fila real (nombres no contiguos, mesa con menos sillas de las
    // que la plantilla fija asume, etc.), antes esto tiraba un error al
    // leer estado.estado sobre undefined. Se trata igual que una silla sin
    // datos: "disponible".
    if (!estado || estado.estado == null || estado.estado == undefined) return "disponible"
    if (estado.cedula != null && estado.cedula != "") {
      if ((estado.cedula == "" || estado.cedula == undefined || estado.cedula == null) && estado.estado.toLowerCase() == "ocupado") return "apartado"
      //if ((estado.cedula != null && estado.cedula != "") && estado.estado.toLowerCase() == "ocupado") return "apartado"
      if (estado.estado.toLowerCase() == "ocupado") return estado.estado.toLowerCase()
      if (user != null && estado.cedula == user.cedula || (estado.cedula == randon && randon != "")) return "seleccionado"

      else return estado.estado.toLowerCase()
      return
    }
    if ((estado.cedula == "" || estado.cedula == undefined || estado.cedula == null) && estado.estado.toLowerCase() == "ocupado") return "apartado"
    else return estado.estado.toLowerCase()
  }
  function MesaEstado(e) {

    if (list.length == 0) {
      return
    }
    let asiento = list.map(function (k) {
      {
        if (k.cedula != "") {
          if (user == undefined) {
            if (k.estado.toLowerCase() == "reservado" && (k.cedula == null || k.cedula == "" || k.cedula == undefined)) return "disponible"
            return k.estado
          }
          if (k.cedula == user.cedula) {
            return ["seleccionado"];
          }
          // if ((k.cedula == "" || k.cedula == undefined || k.cedula == null) && k.estado.toLowerCase() == "ocupado") return "apartado"
          else { return k.estado }
        }
        else return [k.estado]
      }
    });
    const isSeleccion = (currentValue) => currentValue == "seleccionado";
    const isApartado = (currentValue) => currentValue == "apartado";
    const isOcupado = (currentValue) => currentValue == "Ocupado" || currentValue == "OCUPADO";
    const isReserva = (currentValue) => currentValue == "RESERVADO" || currentValue == "reservado";
    const isDispon = (currentValue) => currentValue == "disponible" || currentValue == "DISPONIBLE";
    const isDisnone = (currentValue) => currentValue == "none" || currentValue == "d-none";
    let mesas = ["A", "B", "C", "D"]
    let sillabloquea = ["D42", "D41", "D40", "D38", "D39", "D37", "D36"]
    let envotid = sessionStorage.getItem("eventoid")
    if (Object.values(asiento).every(isOcupado)) { return "mesaocupado" }
    if (Object.values(asiento).every(isReserva)) { return "mesareserva" }
    if (Object.values(asiento).every(isSeleccion)) { return "mesaselecion" }
    if (Object.values(asiento).every(isApartado)) { return "mesaapartada" }
    if (Object.values(asiento).every(isDisnone)) { return "none" }
    return "mesadisponible"
  }
  /*  obtener sillas  */
  function obtenerid(e) {
    let silla = list.find(f => f.silla == e)
    return silla && silla.idsilla != undefined ? "silla-" + silla.idsilla : ""
  }
  function sillasid(e) {
    // return
    let info = getDatosUsuariosLocalStorag()
    let estado = list.find(f => f.silla == e).idsilla != undefined ? "silla-" + list.find(f => f.silla == e).idsilla : ""
    let silla = list.find(f => f.silla == e)
    if (info == undefined) {
      return
    }
    if (silla.estado.toLowerCase().includes("reservado") && silla.cedula == null) {
      let datos = {
        id: mapath[0].id,
        cantidad:1,
        "cedula": info.cedula,
        "estado": "disponible",
        random: sessionStorage.getItem("random"),
        "mas": "mas",
        "mesa": [
          {
            id_silla: silla.idsilla,
            id: mapath[0].id,
            cedula: info.cedula,
            random: sessionStorage.getItem("random"),
            estado: "",
            ...silla
          }
        ]
      }
      hideAlert()
      usedispatch(setSpinersli({ spiner: false }))
      console.log("datos", datos)
      correlativosadd(datos).then(ou => {

        usedispatch(setSpinersli({ spiner: false }))
        if (ou.success) {
          ou.insert.map((e => {
            let asiento = silla
            AgregarAsiento({
              "localidad": nombre.localidad, "localidaEspacio": { "idcolor": nombre.id_localidad || nombre.idcolor, "ideprecio": nombre.ideprecio, "espacio": nombre.id_espacio, ...nombre }, "nombreConcierto": sessionStorage.getItem("consierto"), "valor": nombre.precio_normal,
              seleccionmapa: nombre.localidad + "-" + asiento.silla,
              "fila": asiento.silla.split("-")[0], "silla": asiento.silla, "estado": "seleccionado", "ids": asiento.idsilla, "cedula": info.cedula
            })
            usedispatch(addSillas({
              "localidad": nombre.localidad, "localidaEspacio": nombre,
              "nombreConcierto": sessionStorage.getItem("consierto"), "valor": nombre.precio_normal,
              seleccionmapa: nombre.localidad + "-" + asiento.silla, "fila": asiento.silla.split("-")[0],
              "silla": asiento.silla, "estado": "seleccionado"
            }))

          }))
          ou.update.map((e) => {
            let asiento = silla
            usedispatch(deleteSillas({
              "localidad": nombre.localidad,
              "fila": asiento.silla.split("-")[0],
              "silla": asiento.silla,
              "estado": "seleccionado"
            }))
            EliminarsilladeMesa({ localidad: nombre.localidad + "-" + asiento.silla })
          })
          setTimeout(() => {
            usedispatch(setSpinersli({ spiner: true }))
            //   
          }, 1000);


        }
        else {
          usedispatch(setSpinersli({ spiner: true }))
        }
      }).catch(err => {
        logWithCallback(err)
        usedispatch(setSpinersli({ spiner: true }))
      })
    }
    if (silla.estado.toLowerCase().includes("reservado") && (info.cedula != silla.cedula)) {
      return
    }
    if (silla.estado.toLowerCase().includes("reservado") && (info.cedula == silla.cedula)) {
      let datos = {
        "cedula": info.cedula,
        "estado": "disponible",
        "random": sessionStorage.getItem("random"),
        id: mapath[0].id,
        cantidad: 1,
        "mas": "mas",
        "mesa": [
          {
            id_silla: silla.idsilla,
            id: mapath[0].id,
            cedula: info.cedula,
            "random": sessionStorage.getItem("random"),
            estado: "",
            ...silla
          }
        ]
      }
      hideAlert()
      usedispatch(setSpinersli({ spiner: false }))
      console.log("datos1", datos)
      correlativosadd(datos).then(ou => {
        if (ou.success) {
          ou.insert.map((e => {
            let asiento = silla
            AgregarAsiento({
              "localidad": nombre.localidad, "localidaEspacio": { "idcolor": nombre.id_localidad || nombre.idcolor, "ideprecio": nombre.ideprecio, "espacio": nombre.id_espacio, ...nombre }, "nombreConcierto": sessionStorage.getItem("consierto"), "valor": nombre.precio_normal,
              seleccionmapa: nombre.localidad + "-" + asiento.silla,
              "fila": asiento.silla.split("-")[0], "silla": asiento.silla, "estado": "seleccionado", "ids": asiento.idsilla, "cedula": info.cedula
            })
            usedispatch(addSillas({
              "localidad": nombre.localidad, "localidaEspacio": nombre,
              "nombreConcierto": sessionStorage.getItem("consierto"), "valor": nombre.precio_normal,
              seleccionmapa: nombre.localidad + "-" + asiento.silla, "fila": asiento.silla.split("-")[0],
              "silla": asiento.silla, "estado": "seleccionado"
            }))
            let sillaids = document.getElementById("silla-" + e)
            sillaids.classList.remove('disponible')
            sillaids.classList.add('seleccionado')

          }))
          ou.update.map((e) => {
            let asiento = silla
            usedispatch(deleteSillas({
              "localidad": nombre.localidad,
              "fila": asiento.silla.split("-")[0],
              "silla": asiento.silla,
              "estado": "seleccionado"
            }))
            let sillaids = document.getElementById("silla-" + e)
            sillaids.classList.add('disponible')
            sillaids.classList.remove('seleccionado')

            EliminarsilladeMesa({ localidad: nombre.localidad + "-" + asiento.silla })
          })
          setTimeout(function () {
            usedispatch(setSpinersli({ spiner: true }))
          }, 1000)
        } else {
          usedispatch(setSpinersli({ spiner: true }))
        }
      }).catch(err => {
        logWithCallback(err)
      })
      return
    }

    if (silla.estado.toLowerCase().includes("disponible") || silla.cedula == null) {
      let datos = {
        "cedula": info.cedula,
        "estado": "disponible",
        cantidad: 1,
        id: mapath[0].id,
        random: sessionStorage.getItem("random"),
        "mas": "mas",
        "mesa": [
          {
            id_silla: silla.idsilla,
            id: mapath[0].id,
            cedula: info.cedula,
            random: sessionStorage.getItem("random"),
            estado: "",
            ...silla
          }
        ]
      }
      hideAlert()
      usedispatch(setSpinersli({ spiner: false }))
      console.log("datos2", datos)
      correlativosadd(datos).then(ou => {
        usedispatch(setSpinersli({ spiner: false }))
        if (ou.success) {
          ou.insert.map((e => {
            let asiento = silla
            AgregarAsiento({
              "localidad": nombre.localidad, "localidaEspacio": {
                ...nombre,
                "idcolor": nombre.id_localidad || nombre.idcolor, "ideprecio": nombre.ideprecio,
                "espacio": nombre.id_espacio
              }, "id": nombre.id_localidad,
              "nombreConcierto": sessionStorage.getItem("consierto"), "valor": nombre.precio_normal,
              seleccionmapa: nombre.localidad + "-" + asiento.silla,
              "fila": asiento.silla.split("-")[0], "silla": asiento.silla, "estado": "seleccionado", "ids": asiento.idsilla, "cedula": info.cedula
            })
            usedispatch(addSillas({
              "localidad": nombre.localidad, "localidaEspacio": nombre,
              "nombreConcierto": sessionStorage.getItem("consierto"), "valor": nombre.precio_normal,
              seleccionmapa: nombre.localidad + "-" + asiento.silla, "fila": asiento.silla.split("-")[0],
              "silla": asiento.silla, "estado": "seleccionado"
            }))

          }))
          ou.update.map((e) => {
            let asiento = silla
            usedispatch(deleteSillas({
              "localidad": nombre.localidad,
              "fila": asiento.silla.split("-")[0],
              "silla": asiento.silla,
              "estado": "seleccionado"
            }))
            EliminarsilladeMesa({ localidad: nombre.localidad + "-" + asiento.silla })
          })
          setTimeout(() => {
            usedispatch(setSpinersli({ spiner: true }))
            //   
          }, 1000);


        }
        else {
          usedispatch(setSpinersli({ spiner: true }))
        }
      }).catch(err => {
       logWithCallback(err)
        usedispatch(setSpinersli({ spiner: true }))
      })
    }
  }
  function enviarsillas(text) {
    
    let datos = document.getElementById(text).classList.value
    if (datos.includes("none")) {
      return
    }
    if (datos.includes("mesareserva")) {
      return
    }
    if (datos.includes("mesaocupado")) {
      return
    }
    if (datos.includes("mesaapartada")) {
      return
    }
    if (datos.includes("mesaselecion")) {
      modalshow.nombre == "Modallocalida" ? succesDesmar(text) : ''
      return
    }
    let info = getDatosUsuariosLocalStorag()
    if (TotalSelecion() >= 1) {
      usedispatch(setToastes({
        show: true,
        message: 'Debes desmarcar la selección anterior para poder comprar la mesa completa',
        color: 'bg-warning', estado: 'Límite alcanzado'
      }))
      return
    }
    modalshow.nombre == "Modallocalida" ? succesLimit(text) : ''
  }
  const succesLimit = (me) => {
    if (TotalSelecion() >= 10) {
      usedispatch(setToastes({
        show: true,
        message: 'Has alcanzado el limite de selección',
        color: 'bg-warning', estado: 'No puedes seleccionar toda la mesa'
      }))
      return
    }
    setAlert(
      <SweetAlert
        warning
        style={{ display: "block", marginTop: "-100px" }}
        title="Deseas selecionar todas las sillas"
        onConfirm={() => timeposlimites()}
        onCancel={() => hideAlert()}
        confirmBtnBsStyle="success"
        cancelBtnBsStyle="danger"
        confirmBtnText="Si, Continuar"
        cancelBtnText="Cancelar"
        closeAnim={{ name: 'hideSweetAlert', duration: 500 }}
        showCancel>
        En la mesa  {me}
      </SweetAlert>
    )

  }
  const succesSilla = (e) => {
    let mesas = ["A", "B", "C"]
    let mesa = ["A"]
    let sillabloquea = ["A1", "5", "J3"]
    let sillesSAmor = ["C1", "C2", "C3", "C4", "C5", "C6", "C7", "C8", "B4", "B3"]
    let sillasAmor = []
    const randon = sessionStorage.getItem("random") || "" 
    let info = getDatosUsuariosLocalStorag()

    let envotid = sessionStorage.getItem("eventoid")
    const localidadNombre = (nombre && nombre.localidad) ? String(nombre.localidad).trim().toUpperCase() : ''
    const mesaActual = String(text || '').trim().toUpperCase()

    // if ((envotid == 'IZNI26') && clienteInfo() == null) {
    //   const ventaSoloMesaCompleta = ["MESAS VIP .", "MESAS GOLDEN ."]
    //   if (ventaSoloMesaCompleta.includes(localidadNombre)) {
    //     $.confirm({
    //       title: 'Venta por Mesa Completa',
    //       content: `En la localidad <strong>${nombre.localidad}</strong> solo está habilitada la venta por mesa completa.<br>
    //             Seleccione la mesa completa para continuar.`,
    //       type: 'blue',
    //       buttons: {
    //         aceptar: { text: 'Aceptar', btnClass: 'btn-blue' }
    //       }
    //     });
    //     return;
    //   }
    // } 

    if ((envotid == 'ODOK5W' || envotid == 'X40IS5') && clienteInfo() == null) {
      const esVaquerosPremium = localidadNombre === 'VAQUEROS PREMIUM'
      const esDestinoFinalPremiun = localidadNombre === 'DESTINO FINAL PREMIUN'
      const esMesaVentaCompleta = /^[ABC](10|[1-9])$/i.test(mesaActual)

      if ((esVaquerosPremium || esDestinoFinalPremiun) && esMesaVentaCompleta) {
        $.confirm({
          title: 'Venta por Mesa Completa',
          content: `En la localidad <strong>${nombre.localidad}</strong> las mesas <strong>A1 a C10</strong> solo están habilitadas para venta por mesa completa.<br>
                Seleccione la mesa completa para continuar.`,
          type: 'blue',
          buttons: {
            aceptar: { text: 'Aceptar', btnClass: 'btn-blue' }
          }
        });
        return;
      }
    }

    // if ((envotid == '9OSOMP') && clienteInfo() == null) {
    //   const ventaSoloMesaCompleta = ["MESAS VIP*.", "MESAS GOLDEN*."]
    //   if (ventaSoloMesaCompleta.includes(localidadNombre)) {
    //     $.confirm({
    //       title: 'Venta por Mesa Completa',
    //       content: `En la localidad <strong>${nombre.localidad}</strong> solo está habilitada la venta por mesa completa.<br>
    //             Seleccione la mesa completa para continuar.`,
    //       type: 'blue',
    //       buttons: {
    //         aceptar: { text: 'Aceptar', btnClass: 'btn-blue' }
    //       }
    //     });
    //     return;
    //   }
    // } 

    // if ((envotid == 'PEWIHG') && (![...mesas,].includes(text) && clienteInfo() == null)) {
    //   $.confirm({
    //     title: 'Mesas Habilitadas',
    //     content: 'En esta localidad solo están habilitadas las siguientes fila para venta inidividual:<br><strong></strong><br><strong>D Y E,</strong><br>' +
    //       '' +
    //       '',
    //     type: 'blue',
    //     typeAnimated: true,
    //     buttons: {
    //       aceptar: {
    //         text: 'Aceptar',
    //         btnClass: 'btn-blue',
    //         action: function () {
    //         }
    //       }
    //     }
    //   });
    //   return
    // }
 
    if (envotid == 'UG34CO' && clienteInfo() == null) {
      const filaSilla = text.charAt(0).toUpperCase();

   
      const localidadId = (nombre && (nombre.id_localidad ?? nombre.idcolor)) || null;
      const localidadNombre = (nombre && nombre.localidad) ? String(nombre.localidad).toUpperCase() : '';

      let filasPermitidas = ["D", "E"];
      let filasBloqueadas = ["A", "B"]; 
      if (localidadId === 433 || localidadNombre === 'EL KARMA') {
        filasBloqueadas = ["B", "C", "D"];
        filasPermitidas = ["E", "F"];
      }

      else if (localidadId === 428 || localidadNombre === 'TU LA VAS A PAGAR') {
        filasBloqueadas = ["A", "B"];
        filasPermitidas = ["C", "D"];
      }

      // Bloqueo por fila
      if (filasBloqueadas.includes(filaSilla)) {
        $.confirm({
          title: 'Venta por Mesa Completa',
          content: `La fila <strong>${filaSilla}</strong> solo está disponible para venta por mesa completa (10 sillas).<br>
                Para venta individual, seleccione sillas en las filas: <strong>${filasPermitidas.join(' o ')}</strong>.`,
          type: 'blue',
          buttons: {
            aceptar: { text: 'Aceptar', btnClass: 'btn-blue' }
          }
        });
        return;
      }
    }
    if (envotid == 'EMHNKL' && clienteInfo() == null) {
      const localidadNombre = (nombre && nombre.localidad) ? String(nombre.localidad).toUpperCase() : '';
      if (localidadNombre.includes('PALCOS DESPECHADOS')) {
        const mesaNum = parseInt(String(displayMesaNombre(text)).replace(/\D/g, ''), 10);
        if (!isNaN(mesaNum) && mesaNum % 2 === 0) {
          $.confirm({
            title: 'Venta por Mesa Completa',
            content: `La mesa <strong>${displayMesaNombre(text)}</strong> solo está disponible para venta por mesa completa.<br>
                Para venta individual, seleccione sillas en las mesas impares (1, 3, 5, 7, 9, 11).`,
            type: 'blue',
            buttons: {
              aceptar: { text: 'Aceptar', btnClass: 'btn-blue' }
            }
          });
          return;
        }
      }
    }
    if ((envotid == 'F5RKZC') && clienteInfo() == null) {
      const esVaquerosPremium = localidadNombre === 'PALCOS G.B.G.'
      const esMesaVentaCompleta = /^[ABCD](8|[1-9])$/i.test(mesaActual)

      if (esVaquerosPremium && esMesaVentaCompleta) {
        $.confirm({
          title: 'Venta por Mesa Completa',
          content: `En la localidad <strong>${nombre.localidad}</strong> las mesas <strong>A1 a C8</strong> solo están habilitadas para venta por mesa completa.<br>
                Seleccione la mesa completa para continuar.`,
          type: 'blue',
          buttons: {
            aceptar: { text: 'Aceptar', btnClass: 'btn-blue' }
          }
        });
        return;
      }
    }
    if ((envotid == '7EZFQ6') && (![...sillabloquea, ...sillasAmor, ...sillesSAmor].includes(text) && clienteInfo() == null)) return
    /*
   if (((envotid == "X5U5VR") && (clienteInfo() == null) && (mesas.includes(text.split("")[0])) || (sillabloquea.includes(text))) && clienteInfo() == null) return
   if (((envotid == "X5U5VR") && (mesas.includes(text.split("")[0])) && clienteInfo() == null)) {
     return
   }*/
    let silla = list.find(f => f.silla == e)
    if (!silla || silla.idsilla == undefined) return
    if (info == undefined) {
      return
    }
    if (silla.estado.toLowerCase().includes("ocupado") || silla.estado.toLowerCase().includes("none")) {
      return
    }
    if (silla.estado.toLowerCase().includes("reservado") && (silla.cedula == null)) {
      if (TotalSelecion() < 10) {
        setAlert(
          <SweetAlert
            warning
            style={{ display: "block", marginTop: "-100px" }}
            title={"Deseas selecionar "}
            onConfirm={() => sillasid(e)}
            onCancel={() => hideAlert()}
            confirmBtnBsStyle="success"
            cancelBtnBsStyle="danger"
            confirmBtnText="Si, Continuar"
            cancelBtnText="Cancelar"
            closeAnim={{ name: 'hideSweetAlert', duration: 500 }}
            showCancel>
            {"la silla " + e}
          </SweetAlert>)
      }
      return
    }
    if (silla.estado.toLowerCase().includes("reservado") && (info.cedula != silla.cedula)) {
      return
    }
    if (silla.estado.toLowerCase().includes("reservado") && (info.cedula == silla.cedula || (silla.cedula == randon && randon != ""))) {
      setAlert(
        <SweetAlert
          warning
          style={{ display: "block", marginTop: "-100px" }}
          title={"Deseas desmarcar "}
          onConfirm={() => sillasid(e)}
          onCancel={() => hideAlert()}
          confirmBtnBsStyle="success"
          cancelBtnBsStyle="danger"
          confirmBtnText="Si, Continuar"
          cancelBtnText="Cancelar"
          closeAnim={{ name: 'hideSweetAlert', duration: 500 }}
          showCancel>
          {"la sillas " + e}
        </SweetAlert>)
      return
    }
    if (TotalSelecion() < 10) {
      setAlert(
        <SweetAlert
          warning
          style={{ display: "block", marginTop: "-100px" }}
          title={"Deseas selecionar "}
          onConfirm={() => sillasid(e)}
          onCancel={() => hideAlert()}
          confirmBtnBsStyle="success"
          cancelBtnBsStyle="danger"
          confirmBtnText="Si, Continuar"
          cancelBtnText="Cancelar"
          closeAnim={{ name: 'hideSweetAlert', duration: 500 }}
          showCancel>
          {"la sillas " + e}
        </SweetAlert>)
    }
  }
  const succesDesmar = (e) => {
    setAlert(
      <SweetAlert
        warning
        style={{ display: "block", marginTop: "-100px" }}
        title={"Deseas desmarcar toda la seleccion de esta mesa "}
        onConfirm={() => reservas(e)}
        onCancel={() => hideAlert()}
        confirmBtnBsStyle="success"
        cancelBtnBsStyle="danger"
        confirmBtnText="Si, Continuar"
        cancelBtnText="Cancelar"
        closeAnim={{ name: 'hideSweetAlert', duration: 500 }}
        showCancel>
        {"la sillas " + e}
      </SweetAlert>)
  }
  function timeposlimites() {
    let info = getDatosUsuariosLocalStorag()
    let nuevo = list.filter(es => es.estado.toLowerCase() == "disponible").map(({ idsilla, ...e }) => {
      let id = idsilla
      return {
        id_silla: id,
        id: mapath[0].id,
        cedula: info.cedula || "",
        random: sessionStorage.getItem("random"),
        estado: "",
        ...e
      }
    })
    let datos = {
      "cedula": info.cedula,
      "estado": "disponible",
      id: nombre.codigoEvento,
      cantidad: 1,
      "mas": "mas",
      random: sessionStorage.getItem("random"),
      "mesa": [
        ...nuevo,
      ]
    }

    hideAlert()
    usedispatch(setSpinersli({ spiner: false }))
    correlativosadd(datos).then(ou => {
      if (ou.success) {
        ou.insert.map((e => {
          let asiento = list.filter(ef => ef.idsilla == e)
          if (!asiento[0]) return
          AgregarAsiento({
            id: nombre.id_localidad,
            "localidad": nombre.localidad, "localidaEspacio": { "idcolor": nombre.id_localidad || nombre.idcolor,
               "ideprecio": nombre.ideprecio, "espacio": nombre.id_espacio, ...nombre },
                "nombreConcierto": sessionStorage.getItem("consierto"), "valor": nombre.precio_normal,
            seleccionmapa: nombre.localidad + "-" + asiento[0].silla,
            "fila": asiento[0].silla.split("-")[0], "silla": asiento[0].silla, "estado": "seleccionado", "ids": asiento[0].idsilla, "cedula": info.cedula
          })
          usedispatch(addSillas({
            "localidad": nombre.localidad, "localidaEspacio": nombre,
            "nombreConcierto": sessionStorage.getItem("consierto"), "valor": nombre.precio_normal,
            seleccionmapa: nombre.localidad + "-" + asiento[0].silla, "fila": asiento[0].silla.split("-")[0],
            "silla": asiento[0].silla, "estado": "seleccionado"
          }))
          let sillaids = document.getElementById("silla-" + e)
          sillaids.classList.remove('disponible')
          sillaids.classList.add('seleccionado')
        }))
        ou.update.map((e) => {
          let asiento = list.filter(ef => ef.idsilla == e)
          usedispatch(deleteSillas({
            "localidad": nombre.localidad,
            "fila": asiento[0].silla.split("-")[0],
            "silla": asiento[0].silla,
            "estado": "seleccionado"
          }))
          EliminarsilladeMesa({ localidad: nombre.localidad + "-" + asiento[0].silla })
        })
        setTimeout(() => {
          usedispatch(setSpinersli({ spiner: true }))
        }, 1000);
      } else {
        usedispatch(setSpinersli({ spiner: true }))
      }
    }).catch(err => {
      usedispatch(setSpinersli({ spiner: true }))
    })

  }
  function reservas() {
    let info = getDatosUsuariosLocalStorag()
    let nuevo = list.filter(es => es.cedula == info.cedula).map(({ idsilla, ...e }) => {
      let id = idsilla
      return {
        id_silla: id,
        id: mapath[0].id,
        cedula: info.cedula,
        random: sessionStorage.getItem("random"),
        estado: "",
        ...e
      }
    })

    let datos = {
      "cedula": info.cedula,
      "estado": "disponible",
      id: mapath[0].id,
      cantidad: 1,
      "mas":"mas",
      random: sessionStorage.getItem("random"),
      "mesa": [
        ...nuevo
      ]
    }
    hideAlert()
    usedispatch(setSpinersli({ spiner: false }))
    console.log("datos4", datos)
    correlativosadd(datos).then(ou => {
      if (ou.success) {
        ou.insert.map((e => {
          let asiento = list.filter(ef => ef.idsilla == e)
          AgregarAsiento({
            "localidad": nombre.localidad, "localidaEspacio": { "idcolor": nombre.id_localidad || nombre.idcolor, "ideprecio": nombre.ideprecio, "espacio": nombre.id_espacio, ...nombre }, "nombreConcierto": sessionStorage.getItem("consierto"), "valor": nombre.precio_normal,
            seleccionmapa: nombre.localidad + "-" + asiento[0].silla,
            "fila": asiento[0].silla.split("-")[0], "silla": asiento[0].silla, "estado": "seleccionado", "ids": asiento.idsilla, "cedula": info.cedula
          })
          usedispatch(addSillas({
            "localidad": nombre.localidad, "localidaEspacio": nombre,
            "nombreConcierto": sessionStorage.getItem("consierto"), "valor": nombre.precio_normal,
            seleccionmapa: nombre.localidad + "-" + asiento[0].silla, "fila": asiento[0].silla.split("-")[0],
            "silla": asiento[0].silla, "estado": "seleccionado"
          }))
        }))
        ou.update.map((e) => {
          let asiento = list.filter(ef => ef.idsilla == e)
          usedispatch(deleteSillas({
            "localidad": nombre.localidad,
            "fila": asiento[0].silla.split("-")[0],
            "silla": asiento[0].silla,
            "estado": "seleccionado"
          }))
          let sillaids = document.getElementById("silla-" + e)
          sillaids.classList.remove('seleccionado')
          sillaids.classList.add('disponible')
          EliminarsilladeMesa({ localidad: nombre.localidad + "-" + asiento[0].silla })
        })
        usedispatch(setSpinersli({ spiner: true }))

      }
      usedispatch(setSpinersli({ spiner: true }))
    }).catch(err => {
      usedispatch(setSpinersli({ spiner: true }))
    })
  }
  const hideAlert = () => setAlert(null)
  return (
    <div>
      {(() => {
        switch (status) {

          case 2:
            return <MesadosView text={text} list={list}
              obtenerid={obtenerid}
              succesSilla={succesSilla}
              succesLimit={succesLimit}
              Estado={Estado}
              MesaEstado={MesaEstado}
              alert={alertPortal}
              enviarsillas={() => enviarsillas(text)} />;
          case 4:
            return <MesacuatroView text={text} list={list}
              obtenerid={obtenerid}
              succesSilla={succesSilla}
              succesLimit={succesLimit}
              Estado={Estado}
              MesaEstado={MesaEstado}
              alert={alertPortal}
              enviarsillas={() => enviarsillas(text)} />;
          case 6:
            return <MesaseisView text={text} list={list}
              obtenerid={obtenerid}
              succesSilla={succesSilla}
              succesLimit={succesLimit}
              Estado={Estado}
              MesaEstado={MesaEstado}
              alert={alertPortal}
              enviarsillas={() => enviarsillas(text)}
            />;
          case 8:
            return <MesaochoView text={text} list={list}
              obtenerid={obtenerid}
              succesSilla={succesSilla}
              succesLimit={succesLimit}
              Estado={Estado}
              MesaEstado={MesaEstado}
              alert={alertPortal}
              enviarsillas={() => enviarsillas(text)} />;
          case 10:
            return <MesadiesView text={text} list={list}
              obtenerid={obtenerid}
              succesSilla={succesSilla}
              succesLimit={succesLimit}
              Estado={Estado}
              MesaEstado={MesaEstado}
              alert={alertPortal}
              enviarsillas={() => enviarsillas(text)} />;
          case 11:
            return <MesadiesView text={text} list={list}
              obtenerid={obtenerid}
              succesSilla={succesSilla}
              succesLimit={succesLimit}
              Estado={Estado}
              MesaEstado={MesaEstado}
              alert={alertPortal}
              enviarsillas={() => enviarsillas(text)}

            />;
          case 12:
            return <MesadiesView text={text} list={list}
              obtenerid={obtenerid}
              succesSilla={succesSilla}
              succesLimit={succesLimit}
              Estado={Estado}
              MesaEstado={MesaEstado}
              alert={alertPortal}
              enviarsillas={() => enviarsillas(text)}
            />;
          case 13:
          case 14:
            return <MesascatorceView text={text} list={list}
              obtenerid={obtenerid}
              succesSilla={succesSilla}
              succesLimit={succesLimit}
              Estado={Estado}
              MesaEstado={MesaEstado}
              alert={alertPortal}
              enviarsillas={() => enviarsillas(text)}
            />;
          case 15:
          case 16:
          case 17:
          case 18:
          case 19:
          case 20:
            return <MesaExtraView text={text} list={list}
              obtenerid={obtenerid}
              succesSilla={succesSilla}
              succesLimit={succesLimit}
              Estado={Estado}
              MesaEstado={MesaEstado}
              alert={alertPortal}
              enviarsillas={() => enviarsillas(text)}
            />;
          default:
            return <MesacerView text={text} list={list}
              obtenerid={obtenerid}
              succesSilla={succesSilla}
              succesLimit={succesLimit}
              Estado={Estado}
              MesaEstado={MesaEstado}
              alert={alertPortal}
              enviarsillas={() => enviarsillas(text)}

            />;
        }
      })()}
    </div>
  );
}

export default MesasView